var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bonus"},[_c('div',{staticClass:"item"},[_c('span',[_vm._v("环保补助金:")]),_c('span',[_vm._v("-¥"+_vm._s(_vm.product.bonus_price))]),_c('span',[_vm._v("应付金额: ¥")]),_c('span',[_vm._v(_vm._s(_vm.order.amount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }